import React from 'react';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';
import { ValidationError } from '../../api/useGenerateReportMutation';

interface ErrorAlertProps {
  error: Error | ValidationError | null;
  onRequestClose(): void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onRequestClose }) => {
  if (!error) {
    return null;
  }

  if (error instanceof ValidationError) {
    return <Alert variant="error" message={error.message} onRequestClose={onRequestClose} />;
  }

  return (
    <Alert
      variant="error"
      title="Report Failed to Generate"
      message="There was an error loading this report. Please try again later."
      onRequestClose={onRequestClose}
    />
  );
};
